
import { initMarketStockHeaders } from "./../js/marketStockHeader/initMarketStockHeaders.jsx";

initMarketStockHeaders("market-stock-header");
